import React, { useState } from 'react';
import { ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';
import Cart from './Cart';

const Header = ({ cartItems, onRemoveFromCart, onUpdateQuantity, onAddToCart }) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  
  const cartItemCount = cartItems.reduce((sum, item) => sum + item.quantity, 0);
  
  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-warm-ivory/95 backdrop-blur-md border-b border-stone-taupe/20 shadow-sm">
        <div className="container mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <a href="/" className="flex items-center gap-2 hover:scale-105 transition-transform duration-300">
              <img 
                src="https://customer-assets.emergentagent.com/job_partyfavor-design/artifacts/kg186rqs_Photoroom_20260106_152029.png" 
                alt="The Favor" 
                className="h-24 md:h-28 w-auto"
              />
            </a>
            
            <nav className="hidden md:flex items-center gap-8">
              <a href="/#bundles" className="text-charcoal-ink hover:text-stone-taupe transition-all duration-300 relative group">
                Shop Bundles
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-charcoal-ink group-hover:w-full transition-all duration-300"></span>
              </a>
              <a href="/#occasions" className="text-charcoal-ink hover:text-stone-taupe transition-all duration-300 relative group">
                Occasions
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-charcoal-ink group-hover:w-full transition-all duration-300"></span>
              </a>
              <a href="/#how-it-works" className="text-charcoal-ink hover:text-stone-taupe transition-all duration-300 relative group">
                How It Works
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-charcoal-ink group-hover:w-full transition-all duration-300"></span>
              </a>
              <a href="/faq" className="text-charcoal-ink hover:text-stone-taupe transition-all duration-300 relative group">
                FAQ
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-charcoal-ink group-hover:w-full transition-all duration-300"></span>
              </a>
              <a href="/dashboard" className="text-charcoal-ink hover:text-stone-taupe transition-all duration-300 relative group">
                Dashboard
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-charcoal-ink group-hover:w-full transition-all duration-300"></span>
              </a>
            </nav>
            
            <button
              onClick={() => setIsCartOpen(true)}
              className="relative p-2 hover:bg-soft-linen rounded-lg transition-all duration-300 hover:scale-110"
            >
              <ShoppingCart className="w-6 h-6 text-charcoal-ink" />
              {cartItemCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-charcoal-ink text-warm-ivory text-xs w-5 h-5 rounded-full flex items-center justify-center font-medium animate-in shadow-md">
                  {cartItemCount}
                </span>
              )}
            </button>
          </div>
        </div>
      </header>
      
      <Cart
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        cartItems={cartItems}
        onRemoveFromCart={onRemoveFromCart}
        onUpdateQuantity={onUpdateQuantity}
        onAddToCart={onAddToCart}
      />
    </>
  );
};

export default Header;